import * as React from 'react';
import { useState, useContext } from 'react';
import { AuthContext } from '../../Contexts/AuthContext';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import {ArrowBackIos} from "@mui/icons-material";
import TextField from '@mui/material/TextField';
import { Spin, Divider, Alert } from 'antd';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {Brand} from '../../Components/Brand';

const Login = ({isProspect, onBack}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleLogin, loginFailed } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    handleLogin(username, isProspect ? 'tracker' : password);
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs" sx={{background: "#FFF"}}>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Brand/>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
          {!isProspect && ( // Only show the password field if not a prospect login
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          )}
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          {loginFailed===true && (
              <>
                <Alert style={{fontWeight: '600'}} message="Username or Password Not Found" type="error" showIcon />
              </>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color={'primary'}
            sx={{ mt: 3, mb: 2 }}
            startIcon={loading ? <Spin/>:null}
          >
            {loading ? 'Loading' : 'Sign In'}
          </Button>
          <Button startIcon={<ArrowBackIos />} onClick={onBack}>
            Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
